import React, { forwardRef, useEffect } from 'react';
import Progress from 'studio/components/Progress';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Prompt } from 'react-router-dom';

import sx from './Content.styles';

const Content = forwardRef(({ classes, children, loading, hasUnsavedChanges, ...props }, ref) => {
  // sets an unload handler (triggering a browser prompt) if there are unsaved changes
  useEffect(() => {
    window.onbeforeunload = hasUnsavedChanges ? () => true : undefined;
  }, [hasUnsavedChanges]);

  return (
    <Box sx={sx.root} {...props}>
      {loading ? (
        <Progress />
      ) : (
        <>
          <Toolbar variant="dense" />
          <Box sx={sx.content} ref={ref}>
            {children}
          </Box>
        </>
      )}
      {hasUnsavedChanges && <Prompt message="You have unsaved changes. Do you really want to leave the page?" />}
    </Box>
  );
});

export default Content;
